import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Stack } from "@volca/ui/components/ui/stack";
import { cn } from "@volca/ui/lib/utils";

/** One bubble's worth of lines, at the widths a real message runs to. */
const OWNER = ["w-40", "w-52"];
const REPLY = ["w-full", "w-11/12", "w-4/5", "w-2/3"];

export const TranscriptSkeleton = () => (
  <Stack
    gap={0}
    align="stretch"
    direction="column"
    role="status"
    aria-label="Loading your conversation…"
    className="flex min-h-0 flex-1 flex-col justify-end gap-4 px-5 py-5"
  >
    <Stack
      gap={0}
      align="stretch"
      direction="column"
      aria-hidden
      className="flex flex-col items-end gap-2 opacity-40"
    >
      {OWNER.map((width) => (
        <Skeleton key={width} className={cn("h-3", width)} />
      ))}
    </Stack>
    <Stack
      gap={0}
      align="stretch"
      direction="column"
      aria-hidden
      className="flex flex-col gap-2 opacity-60"
    >
      {REPLY.map((width) => (
        <Skeleton key={width} className={cn("h-3", width)} />
      ))}
    </Stack>
    <Stack
      gap={0}
      align="stretch"
      direction="column"
      aria-hidden
      className="flex flex-col items-end gap-2"
    >
      {OWNER.map((width) => (
        <Skeleton key={width} className={cn("h-3", width)} />
      ))}
    </Stack>
  </Stack>
);
